import { useEffect } from 'react'
import '@/style/intro.scss'
import PageHero from '@/components/PageHero'
import Reveal from '@/components/Reveal'
import heroImg from '@/images/site/hero-intro.jpg'
import companyImg from '@/images/site/company.jpg'

const PROFILE = [
  { label: '企业名称', value: '丰源电力科技（涿州）有限公司' },
  { label: '法定代表人', value: '郭振丰' },
  { label: '注册资本', value: '1000 万元' },
  { label: '注册地址', value: '河北省保定市涿州市高官庄镇解家楼村村北' },
]

const OVERVIEW =
  '丰源电力科技（涿州）有限公司成立于 2008 年，位于河北省保定市涿州市，是一家专业从事电工绝缘材料开发、设计和应用的民营企业。'

const CAPABILITY =
  '公司核心产品为 SMC 板、SMC/DMC 模压制品、GPO-3 产品、注塑制品、PC 制品、膜切制品，及各种工程塑料的深加工制品。'

const FIELDS = ['石油化工', '电力', '电气', '电子', '机械']

/* 经营范围：金属结构件及电力电子元器件加工销售等 */
const BUSINESS = [
  '金属结构件',
  '机械',
  '电力电子元器件',
  '塑料零件',
  '金属密封件',
  '模具',
  '橡胶零件',
  '汽车零配件',
]

function Intro() {
  useEffect(() => {
    const type = new URLSearchParams(window.location.search).get('type')
    if (!type) return
    const el = document.getElementById(type)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  return (
    <>
      <PageHero
        eyebrow="About Fengyuan"
        title="关于我们"
        image={heroImg}
        stat={[
          { value: '2008', label: '成立年份' },
          { value: '1000万', label: '注册资本' },
        ]}
      />

      {/* ---------- 公司简介 ---------- */}
      <section className="section intro__overview" id="overview">
        <div className="mainContent">
          <Reveal className="secHead">
            <p className="secHead__eyebrow">Company Profile</p>
            <h2 className="secHead__title">公司简介</h2>
          </Reveal>

          <div className="intro__grid">
            <Reveal className="intro__media" delay={80}>
              <img src={companyImg} alt="丰源电力厂区" />
            </Reveal>

            <div className="intro__text">
              <Reveal delay={140}>
                <p className="intro__lead">{OVERVIEW}</p>
              </Reveal>
              <Reveal delay={220}>
                <p className="intro__body">{CAPABILITY}</p>
              </Reveal>

              <Reveal delay={300}>
                <div className="intro__fields">
                  <span className="intro__fieldsLabel">应用领域</span>
                  <ul>
                    {FIELDS.map((f) => (
                      <li key={f}>{f}</li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- 企业信息 ---------- */}
      <section className="section section--soft intro__info" id="basicInfo">
        <div className="mainContent">
          <Reveal className="secHead">
            <p className="secHead__eyebrow">Basic Information</p>
            <h2 className="secHead__title">企业信息</h2>
          </Reveal>

          <Reveal className="intro__infoGrid" delay={80}>
            {PROFILE.map((item) => (
              <div className="infoCard" key={item.label}>
                <span className="infoCard__label">{item.label}</span>
                <p className="infoCard__value">{item.value}</p>
              </div>
            ))}
          </Reveal>
        </div>
      </section>

      {/* ---------- 经营范围 ---------- */}
      <section className="section intro__scope" id="businessScope">
        <div className="mainContent">
          <Reveal className="secHead">
            <p className="secHead__eyebrow">Business Scope</p>
            <h2 className="secHead__title">经营范围</h2>
            <p className="secHead__desc">
              电力技术开发、咨询和推广应用，以及金属结构件及电力电子元器件的加工销售。
            </p>
          </Reveal>

          <Reveal className="intro__scopeList" delay={90}>
            {BUSINESS.map((item) => (
              <span className="scopeChip" key={item}>
                {item}
              </span>
            ))}
            <span className="scopeChip">电子元器件</span>
            <span className="scopeChip">五金产品</span>
            <span className="scopeChip">建筑材料</span>
          </Reveal>
        </div>
      </section>

          </>
  )
}

export default Intro